import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { ForgotPasswordMember } from '../../service/UserService';


export default function ForgotPassword() {

  const { setIsLoading, setAppError, setAppErrorMessage, setAppErrorTitle, setAppErrorMode } = useGlobalContext();

  //create two useState variables email and password
  const [email, setemail] = useState("");


  const makeLogin = async () => {

    if (email === "") {
      setAppError(true);
      setAppErrorMessage("Email are required");
      setAppErrorTitle("Form Validation Error");
      setAppErrorMode("error");
      return;
    }

    setIsLoading(true);
    try {
      const response = await ForgotPasswordMember(email);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "Password sent to your email ");
        setAppErrorMode("success");
        window.location.href = "/ForgotPassword";
      }
      else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to forgot password. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to forgot password. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Login | {config.appName} </title>
      </Helmet>
      <div className='container'>
        <div className='row justify-content-center'>
          <div className='col col-md-4'>
            <h4 className='mt-5 text-center login-title'> Forgot Password </h4>   
            <div className='login'>
              <div className='logo-image-container'>
                <img src={config.logo} alt="Oonovoo Logo" />
              </div>
              <div className="login-form">
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="form-group">
                    <label >Email</label>
                    <input className='form-control' type="email" id="email" name="email" value={email} onChange={(e) => setemail(e.target.value)} />
                  </div>
                  <div className="form-group">
                    <button type="submit" className='btn btn-success-app' onClick={makeLogin}>Submit</button>
                  </div>
                </form>
              </div>
            </div>
            <br></br>
            <div className="form-group text-right">
              <Link to="/login" className="text-primary small">
                 Please log in.
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}